import baseAPI from "@/http";

const router = "api/seloDiagnosticoResposta";
import { atualUfDefinition } from "@/helpers/utils";

export const seloDiagnosticoRespostaAPI = {
  list: (municipioId) =>
    baseAPI.get(
      `${router}/obter-diagnostico-resposta-por-municipio/${municipioId}`
    ),
  atualizar: (resposta) =>
    baseAPI.put(`${router}/atualizar-diagnostico-resposta`, resposta),
  delete: (respostaId) => baseAPI.delete(`${router}/${respostaId}`),
  enviarAnalise: (municipioId) =>
    baseAPI.put(`${router}/setar-enviada/${municipioId}`),
  downloadPdf: (municipioId) =>
    baseAPI.get(
      `${router}/selo-diagnostico-pdf-by-municipioId/${municipioId}`,
      { responseType: "blob" }
    ),
  getRespostaPergunta: (perguntaId, municipioId) =>
    baseAPI.get(
      `${router}/obter-diagnostico-resposta-por-pergunta-municipio/${perguntaId}/${municipioId}?uf=${atualUfDefinition.uf}&parceiro=${atualUfDefinition.isParceiro}&ambiente=${atualUfDefinition.ambient}`
    ),
};
